import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const postReport = async (payload) => {
  try {
    const res = await postRequest({
      url: "/reports",
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const putReport = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "/reports",
      query: { report_id: id },
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getReports = async (query) => {
  try {
    const res = await getRequest({
      url: "/reports",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
